/* eslint-disable @typescript-eslint/no-explicit-any */
// import { SERVICE_TYPES } from "common/constants/Constants";
import endpoints from "./endpoints";
import httpClient from "./httpClient";
import { DeleteAPIRequestBody, GetUsersAPIRequest, UserDetails } from "features/adminUserManagement/interfaces/userManagement.interface";
import { AdminDashboardMetricsAPIRequest, SubscribedUsersAPIRequest, TransactionAPIRequest } from "types/interfaces/apiRequest";

const server = {
  login: {
    loadLogin: async (payload: any) => await httpClient.post(endpoints.login.resource, payload),
  },
  getQuickSightDashboard: {
    loadDashboard: async () => await httpClient.get(endpoints.quicksight.resource),
    createUserSession: async (payload: any) => await httpClient.post(endpoints.createUserSessions.resource, payload),
  },
  adminDashboard: {
    // fetchSessionsData
    getSessionsData: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(
        `${endpoints.getMonthlyCount.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}&service_name=${payload.serviceName}`,
      ),

    // fetchSessionLengthData
    getSessionLength: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(`${endpoints.getSessionCount.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}`),

    // fetchRevenueData
    getRevenueData: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(`${endpoints.getRevenueData.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}`),

    getDashboardSessionsData: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(`${endpoints.getDashboardData.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}`),

    getPurchasesData: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(`${endpoints.getPurchasesData.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}`),

    getTransactionsData: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(`${endpoints.getTransactionsData.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}`),

    getSubscribedUserReports: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(`${endpoints.getMonthlyCount.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}`),
    getMonthlyData: async (payload: AdminDashboardMetricsAPIRequest) =>
      await httpClient.get(
        `${endpoints.getMonthlyCount.resource}?start_date=${payload.startDate}&end_date=${payload.endDate}&service_name=${payload.serviceName}`,
      ),
    getSubscribedUsers: async (payload: SubscribedUsersAPIRequest) =>
      await httpClient.get(`${endpoints.getSubscribedUsers.resource}?limit=${payload.limit}&page=${payload.page}`),
    getMasterDataset: async () => await httpClient.get(endpoints.masterDataset.resourvce),
  },
  adminUserManagement: {
    getUsers: async (payload: GetUsersAPIRequest) =>
      await httpClient.get(`${endpoints.getUsers.resource}?limit=${payload.limit}&page=${payload.page}`),
    getUserDetailsFromEmail: async (payload: GetUsersAPIRequest) =>
      await httpClient.get(`${endpoints.getUsers.resource}?limit=${payload.limit}&page=${payload.page}&email__eq=${payload.email}`),
    deleteUser: async (payload: DeleteAPIRequestBody, id: number) =>
      await httpClient.delete(`${endpoints.deleteUser.resource}/${id}`, { data: payload }),
    createNewUser: async (payload: UserDetails) => await httpClient.post(`${endpoints.createNewUser.resource}`, payload),
    updateUser: async (payload: UserDetails, id: number) => await httpClient.put(`${endpoints.updateUser.resource}/${id}`, payload),
    getUserAuditLogs: async (payload: GetUsersAPIRequest) =>
      await httpClient.get(`${endpoints.getUserAuditLogs.resource}?limit=${payload.limit}&page=${payload.page}`),
  },
  pricingDashboard: {
    getPlans: async () => await httpClient.get(`${endpoints.getPlans.resource}?limit=100&page=1`),
    getPlagetPurchaseMappingns: async () => await httpClient.get(`${endpoints.getPurchaseMappingns.resource}`),

    getStates: async (payload: GetUsersAPIRequest) =>
      await httpClient.get(`${endpoints.getStates.resource}?limit=${payload.limit}&page=${payload.page}`),
    getPricingDetails: async (payload: any) => await httpClient.post(``, [payload]),
    getPricingFiltersAction: async (payload: any) => await httpClient.post("", [payload]),
    getRegionsAndHospitals: async (payload: any) => await httpClient.post(`${endpoints.getRegionsAndHospitals.resource}`, payload),
  },
  stripePayment: {
    getPublishKey: async () => await httpClient.get(endpoints.getStripePublishKey.resource),
    getClientSecret: async (payload: string) => await httpClient.post(endpoints.getStripeClientSecret.resource, payload),
    postTransactionDetails: async (payload: TransactionAPIRequest) => await httpClient.post(endpoints.postTransactionDetails.resource, payload),
    getGeneratedDatasetURL: async (payload: any) =>
      httpClient.get(`${endpoints.getGeneratedDatasetURL.resource}?customer_name=${payload?.customerName}&stripe_intent_id=${payload?.paymentId}`),
    deletePaymentIntent: async (paylaod: any) => httpClient.delete(endpoints.deleteStripePaymentIntent.resource, { data: paylaod }),
    generateDataSet: async (payload: any) => httpClient.post(endpoints.generateDataset.resource, payload),
  },
  transactionLogs: {
    getTransactionLogs: async (payload: any) =>
      httpClient.get(
        `${endpoints.transactionLogs.resource}?start_date=${payload.startTime}&end_date=${payload.endTime}&is_hospital_selected=${payload?.isHospitalSelected}&limit=${payload.limit}&page=${payload.page}${payload?.search ? `&search=${payload?.search}` : ""}${payload?.paymentStatus ? `&transaction_status__eq=${payload?.paymentStatus}` : ""}${payload?.state ? `&transaction_region__eq=${payload?.state}` : ""}`,
      ),
    getSpecificTransactionLog: async (payload: any) =>
      httpClient.get(
        `${endpoints.transactionLogs.resource}?start_date=${payload.startTime}&end_date=${payload.endTime}&is_hospital_selected=${payload?.isHospitalSelected}&limit=${payload.limit}&page=${payload.page}&transaction_id__eq=${payload?.transactionId}`,
      ),
    resendDataset: async (payload: any) => await httpClient.post(`${endpoints.resendDataset.resource}`, payload),
  },
};

export default server;
